// extracted by mini-css-extract-plugin
export default {"root":"Pagination_root__XxIKH"};